export const DISTANCE_BETWEEN_LAYERS = 40;
